import ResourceExplorer from './ResourceExplorer';
export default ResourceExplorer;